module.exports = "/_next/static/images/regulatory-compliance-form-958952afe914411980bb395ff7e21646.webp";